// Uppercase in the DOM, not only via CSS: screen readers read the text itself, and a lowercase "a" sounds like the article
export const numberToAlphabet = (index: number): string => (index + 10).toString(36).toUpperCase();
